import React, { useEffect, useState } from "react";
import { Cookies } from '../../../../index.js';
import { alert_error, alert_success } from '../../../../AppContext';
import axios from 'axios';
import { Helmet } from "react-helmet";
import Mode_zalo_mem from '../mode_social/mode_zalo_mem.jsx';
import Mode_tele_mem from '../mode_social/mode_tele_mem.jsx';
import Mode_reports from './mode_reports.jsx';
import Mode_ptc_ads from './mode_ptc_ads.jsx';
import Mode_vip_code from './mode_vip_code.jsx';
import Mode_ads_max from '../mode_system/mode_ads_max.jsx';
import { RingLoader, BarLoader } from "react-spinners";
import Buylink from './../../urlshorten_system/buy_link.jsx';
import Login_google from './.././../login';
import { useSelector, useDispatch } from 'react-redux';

const AboutUs = (props) => {
    const capdo = props.data;
    const money = props.money;
    const [base64Image_1, setBase64Image_1] = useState(null);
    const [base64Image_2, setBase64Image_2] = useState(null);
    const [nutxuly, setnutxuly] = useState(0);
    const [nutorder, setnutorder] = useState('Bước 4: Ấn xác nhận');
    const [data_ok, setdata_ok] = useState(null);
    const [apikey, setapikey] = useState(false);
    const [datajoptiktok, setDatajoptiktok] = useState('');
    const [hustmediavipro, sethustmediavipro] = useState("");
    const media_link_url = useSelector(state => state.media_link_url);
    const media_link_phone = useSelector(state => state.media_link_phone);

    useEffect(() => {
        sadasdasdasdasd();
        const hustmediavipro = Cookies.get("hustmediavipro");
        sethustmediavipro(hustmediavipro);
        const myCookieValue = Cookies.get("apikey");
        setapikey(myCookieValue);
    }, []);
    function sadasdasdasdasd() {
        const myCookieValue = Cookies.get("apikey");
        const code_item = Cookies.get("code_item");
        const hustmediavipro = Cookies.get("hustmediavipro");
        axios.get('https://hust.media/link/load_mode/mode_image_check_start.php', {
            params: {
                lienket: hustmediavipro,
                apikey: myCookieValue,
                code_item: code_item
            },
        })
            .then(response => {
                console.log(response.data);
                if (response.data.status != 1 && response.data.message != '') {
                    alert_error(response.data.message);
                    //   chuyenhuong(response.data);
                }
                else if (response.data.status == 1) {
                    setDatajoptiktok(response.data.datajop[0]);
                    setdata_ok(response.data.datajop);
                    console.log(response.data.datajop[0]);
                    if (response.data.datajop[0].magiaodich) {
                        // setLinkweb(response.data.datajop[0].lienketjop);
                        alert_success('Lấy dữ liệu jop thành công');
                        console.log(response.data.datajop);
                    }
                }
                else {
                    alert_error('Đã xảy ra lỗi máy chủ vui lòng liên hệ admin');
                }
                // testFunction(response);
            })
            .catch(error => {
                console.error(error);
            });
    };
    const handleImageChange_1 = (e) => {
        const file = e.target.files[0];

        if (file) {
            const reader = new FileReader();

            reader.onloadend = () => {
                setBase64Image_1(reader.result);
            };

            reader.readAsDataURL(file);
        }
    };
    const handleImageChange_2 = (e) => {
        const file = e.target.files[0];

        if (file) {
            const reader = new FileReader();

            reader.onloadend = () => {
                setBase64Image_2(reader.result);
            };

            reader.readAsDataURL(file);
        }
    };
    function handleSubmit(event) {
        setnutxuly(1);
        const apikey = Cookies.get('apikey');
        event.preventDefault();
        setnutorder('Please wait a moment 😊');
        if (!base64Image_2 && !base64Image_1 && !datajoptiktok.category.includes('tele_mem')) {
            alert_error('Please điền đầy đủ thông tin')
            setnutxuly(0);
            setnutorder('điền đủ thông tin');
            return
        }
        const code_item = Cookies.get("code_item");
        const hustmediavipro = Cookies.get("hustmediavipro");
        const url = 'https://hust.media/link/load_mode/mode_image_check_end.php';
        let data = JSON.stringify({
            "apikey": apikey,
            "code_item": code_item,
            "lienket": hustmediavipro,
            "id_jop": datajoptiktok.id,
            "magiaodich": datajoptiktok.magiaodich,
            "media_link_url": media_link_url,
            "media_link_phone": media_link_phone,
            "image_1": base64Image_1,
            "image_2": base64Image_2,
        });
        axios.post(url, data)
            .then(
                response => (testFunction(response))
            )
            .catch(error => errorapi(error))

    };
    function errorapi(error) {
        alert_error(error);
        setnutxuly(0);
    };
    function testFunction(response) {
        setnutxuly(0);
        const info = response.data;
        const status = info.status;
        const message = info.message;
        setnutorder('đặt tiếp luôn nào')
        if (status == 0) {
            alert_error(info.message);
        }
        else if (status == 1) {
            alert_success(info.message);
        }
        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 1700);
        }
    };


    // trong component của bạn
    const renderMode = () => {
        const cat = datajoptiktok?.category || "";

        if (cat.includes("mess") || cat.includes("zalo")) {
            return (
                <Mode_zalo_mem
                    datajoptiktok={datajoptiktok}
                    base64Image_1={base64Image_1}
                    handleImageChange_1={handleImageChange_1}
                />
            );
        }

        if (cat.includes("reports")) {
            return (
                <Mode_reports
                    datajoptiktok={datajoptiktok}
                    base64Image_1={base64Image_1}
                    handleImageChange_1={handleImageChange_1}
                />
            );
        }

        if (cat.includes("ptc_ads")) {
            return (
                <Mode_ptc_ads
                    datajoptiktok={datajoptiktok}
                    base64Image_1={base64Image_1}
                    handleImageChange_1={handleImageChange_1}
                />
            );
        }

        if (cat.includes("ads_max")) {
            return (
                <Mode_ads_max
                    base64Image_1={base64Image_1}
                    handleImageChange_1={handleImageChange_1}
                    base64Image_2={base64Image_2}
                    handleImageChange_2={handleImageChange_2}
                />
            );
        }

        if (cat.includes("vip_code")) {
            return (
                <Mode_vip_code
                    datajoptiktok={datajoptiktok}
                    base64Image_1={base64Image_1}
                    handleImageChange_1={handleImageChange_1}
                    base64Image_2={base64Image_2}
                    handleImageChange_2={handleImageChange_2}
                />
            );
        }

        if (cat.includes("tele_mem")) {
            return (
                <Mode_tele_mem
                    datajoptiktok={datajoptiktok}
                    base64Image_1={base64Image_1}
                    handleImageChange_1={handleImageChange_1}
                    base64Image_2={base64Image_2}
                    handleImageChange_2={handleImageChange_2}
                />
            );
        }

        return null; // hoặc <></> nếu bạn muốn render fragment rỗng
    };

    return (
        <div className=" justify-center items-center mt-1">
            {/* <Helmet>
                <title>Hướng dẫn vượt link Hust Media</title>
            </Helmet> */}
            {apikey ? (<><Buylink money={money} hustmediavipro={hustmediavipro} /></>) : (<>
                <div className="mb-1 ">
                    <div>Đăng nhập google để nhận link miễn phí</div>
                    <Login_google />
                </div>
                <div className="mb-1 ">Hoặc:</div>
            </>)}
            <div className="justify-center items-center flex">
                <div className="max-w-xl bg-white shadow-lg rounded-lg overflow-hidden">
                    <div className="px-1 py-3">
                        <div className="font-bold text-base mb-1">Hướng dẫn xem link Hust Media</div>
                        {
                            datajoptiktok ? (<>
                                {renderMode()}
                            </>) : (
                                <div className="mt-2 flex justify-center items-center">
                                    <BarLoader size={50} color="#003AA5" />{" "}
                                </div>
                            )
                        }
                        <button disabled={nutxuly == 1} onClick={handleSubmit}
                            className='mt-2 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-2 w-full dark:bg-slate-800 dark:text-white'>
                            <div className='flex items-center justify-between flex-1'>
                                {nutxuly == 1 &&
                                    <div className="spinner-border" role="status">

                                    </div>}


                                <span className='text-lg font-medium text-white'>
                                    {nutorder} </span>
                                <div className="text-xl">
                                    {'\u27A4'}
                                </div>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutUs;
